import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../reducer/slice/userSlice';

export const useUserSession = (user) => {
    const dispatch = useDispatch()

    useEffect(() => {
        let userSession = JSON.parse(sessionStorage.getItem('user'))
        if (user) {
            dispatch(setUser({ user: userSession }))
        }
    }, [])
}
